export default __webpack_public_path__ + "static/media/home.9e5b8e5a.svg";